import PropTypes from 'prop-types';
import CategoryProp from './categoryProp';

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.number,
  updatedAt: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  unit: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  isNumber: PropTypes.arrayOf(PropTypes.bool),
  translations: PropTypes.object,
  category: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(CategoryProp.propType),
  ]),
  highlight: PropTypes.bool,
};

export default { propType };
